import { Box, Typography } from '@mui/material'

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        textAlign: 'center',
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        mt: 4,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Created by Alexandru Dinca
      </Typography>
    </Box>
  )
}

export default Footer

